/**
 * Created by Mateusz Lipowski on 27.01.2017.
 */
/// <reference path="../MapEntity.ts"/>

namespace Entity.Map.Marker {
    export abstract class Marker extends Entity.Map.MapEntity {

        protected static ICON_PATH = 'https://chart.apis.google.com/chart?';
        protected static ICON_DRAG = '/img/marker-drag.png';

        protected chst: string = 'd_map_spin';
        protected chld: string = '';
        protected defaultColor: string = 'FFFFFF';

        protected _marker: google.maps.Marker;
        protected _map: google.maps.Map;
        protected _lat: number;
        protected _lng: number;
        protected _isVisible: boolean = true;
        protected _decorators: Array<Entity.Map.Marker.Decorator.Decorator>;

        public constructor(lat: number, lng: number, map: google.maps.Map) {
            super();
            this._lat = lat;
            this._lng = lng;
            this._map = map;
            this._decorators = [];
        }

        public appendDecorator(decorator: Entity.Map.Marker.Decorator.Decorator) {
            this._decorators.push(decorator);
        }

        public removeDecorator(decorator: Entity.Map.Marker.Decorator.Decorator) {
            this._decorators.splice(this._decorators.indexOf(decorator), 1);
        }

        public setMap(map: google.maps.Map): void {
            this._map = map;
            if (this._marker) {
                this._marker.setMap(map);
            }
            this._decorators.forEach(decorator => {
                decorator.setMap(map);
            });
        }

        public setPosition(latLng: google.maps.LatLng) {
            this._marker.setPosition(latLng);
            this._decorators.forEach(decorator => {
                decorator.setPosition(latLng);
            });
        }

        public getPosition(): string {
            return `${this._lat},${this._lng}`;
        }

        public getPositionObject(): google.maps.LatLng {
            if (this._marker)
                return this._marker.getPosition();

            return new google.maps.LatLng(this._lat, this._lng);
        }

        public toggleVisibility() {
            if (!this._marker)
                return;

            if (this._marker.getMap() != null)
                this._marker.setMap(null);
            else
                this._marker.setMap(this._map);
        }

        public determineVisibility() {
            if (!this._marker || !this._map)
                return;

            this.show();
        }

        protected onClick(params): void {

        }

        protected show(): void {
            this._marker.setVisible(true);
            this._decorators.forEach(decorator => {
                decorator.setVisible(true);
            });
            this._isVisible = true;
        }

        protected hide(): void {
            this._marker.setVisible(false);
            this._decorators.forEach(decorator => {
                decorator.setVisible(false);
            });
            this._isVisible = false;
        }

        protected initializeMarker(): void {
            this._marker = new google.maps.Marker({
                position: this.getPositionObject(),
                icon: this.getIconObject(),
            });

            this._marker.addListener('click', (params) => {
                App.getInstance().service.callbackContainer.invokeCallbacks(Control.CallbackContainer.CallbackSource.MARKER, new Control.CallbackContainer.Event('click', this, params));
                this.onClick(params);
            });

            this._marker.addListener('rightclick', (params) => {
                App.getInstance().service.callbackContainer.invokeCallbacks(Control.CallbackContainer.CallbackSource.MARKER, new Control.CallbackContainer.Event('rightclick', this, params));
            });

            this._marker.addListener('drag', (params) => {
                App.getInstance().service.callbackContainer.invokeCallbacks(Control.CallbackContainer.CallbackSource.MARKER, new Control.CallbackContainer.Event('drag', this, params));
            });

            this._marker.addListener('dragend', (params) => {
                App.getInstance().service.callbackContainer.invokeCallbacks(Control.CallbackContainer.CallbackSource.MARKER, new Control.CallbackContainer.Event('dragend', this, params));
            });

            this.body = this._marker;
            this.setupInputEvent(InputEvent.RightClick, (params => {
                App.getInstance().service.contextMenu.show(this, new Action.UserActionEvent(this, params, null));
            }));
        }

        protected getIconObject(): Object {
            return this.getIconPath();
        }

        protected getIconPath(): string {
            return Marker.ICON_PATH + 'chst=' + this.chst + '&chld=' + this.chld;
        }

        protected setGpsFlags(flags: Array<string> = []) {
            const {mapContainer} = App.getInstance().service;

            if (flags.length) {
                mapContainer.appendGpsFlags(this, new google.maps.LatLng(this._lat, this._lng), flags);
            }
        }

        protected createGPSDetails(gps, zoom) {
            const gpsElement = document.createElement('div'),
                orientPointSpan = document.createElement('span'),
                orientPointButton = document.createElement('i'),
                directPointButton = document.createElement('i'),
                [gpsPosition, flagsString] = gps.split(';'),
                gpsFlags = (flagsString && flagsString.split('')) || [];

            gpsElement.innerHTML = `<a href="?center=${gps}&zoom=${zoom}">${gpsPosition}</a>`;

            orientPointSpan.className = 'gps-point-type';
            orientPointButton.className = 'icon-circlerecord button-icon';
            directPointButton.className = 'icon-circlerecordempty button-icon';

            orientPointButton.title = 'Ustaw punkt jako orientacyjny';
            directPointButton.title = 'Ustaw punkt jako dokładny';

            if (gpsFlags.indexOf('o') !== -1) {
                orientPointButton.classList.add('disabled');
            } else {
                directPointButton.classList.add('disabled');
            }

            const requestSender: Logic.RequestSender = new Logic.RequestSender(),
                sendRequest = (params: object, callback) => {
                    requestSender.sendRequest('SetGpsPointType', params, (action: string, fields: Object, response: any) => {
                        const
                            alertType = requestSender.isError() ? Entity.View.AlertType.ERROR : Entity.View.AlertType.SUCCESS,
                            alert = new Entity.View.Alert(alertType, requestSender.getMessage());

                        alert.show();

                        callback(requestSender.isError(), response);
                    });
                },
                orientButton = {
                    setDisabled: isDisabled => orientPointButton.classList[isDisabled ? 'add' : 'remove']('disabled'),
                    onClick: <Function>() => null
                },
                directButton = {
                    setDisabled: isDisabled => directPointButton.classList[isDisabled ? 'add' : 'remove']('disabled'),
                    onClick: <Function>() => null
                }

            orientPointButton.addEventListener('click', () => {
                if (!orientPointButton.classList.contains('disabled')) {
                    orientButton.onClick();
                }
            });

            directPointButton.addEventListener('click', () => {
                if (!directPointButton.classList.contains('disabled')) {
                    directButton.onClick();
                }
            });

            orientPointSpan.appendChild(orientPointButton)
            orientPointSpan.appendChild(directPointButton);

            gpsElement.appendChild(orientPointSpan);

            return {
                element: gpsElement,
                request: sendRequest,
                buttons: {
                    orient: orientButton,
                    direct: directButton
                }
            };
        }

        get color(): string {
            return this.defaultColor;
        }

        get marker(): google.maps.Marker {
            return this._marker;
        }
    }
}